import React from 'react';
import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';

export const schemaEntityConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Description', 'IsEntitySet', 'Disjointed', 'Invokable'],
    tableFlags: { itemsPerPage: 100 },
    listColumns: ({ isStandard }: ColumnOptions) => {
        const columns = [
            {
                key: 'description',
                label: 'Description',
                sortable: true,
                render: (entity: any) => {
                    const desc = (entity.Description || '').toString().trim();
                    if (!desc) return '';
                    return desc.length > 50 ? <span title={desc}>{desc.slice(0, 47)}...</span> : desc;
                }
            },
            {
                key: 'isentityset',
                label: 'Kind',
                sortable: true,
                render: (entity: any) => {
                    const isSet = entity.IsEntitySet === true || entity.IsEntitySet === 'true' || entity.IsEntitySet === 'True';
                    return isSet ? <Badge variant="light" size="sm" color="blue">Entity Set</Badge> : '';
                }
            }
        ];

        if (!isStandard) {
            columns.push(
                {
                    key: 'disjointed',
                    label: 'Disjointed',
                    sortable: true,
                    render: (entity: any) => {
                        const val = entity.Disjointed === true || entity.Disjointed === 'true' || entity.Disjointed === 'True';
                        return val ? <Badge variant="light" size="sm" color="orange">Disjointed</Badge> : '';
                    }
                },
                {
                    key: 'invokable',
                    label: 'Invokable',
                    sortable: true,
                    render: (entity: any) => {
                        const val = entity.Invokable === true || entity.Invokable === 'true' || entity.Invokable === 'True';
                        return val ? <Badge variant="light" size="sm" color="violet">Invokable</Badge> : '';
                    }
                }
            );
        }

        return columns;
    }
};
